export default (theme) => ({
  worldIcon: {
    fill: theme.palette.font.main,
    width: 16,
    height: 16,
    marginRight: 8,
    transform: 'translateY(1px)',
  },
});
